// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "PreviewErrorScreen-module--arrow-up-and-down--f931d";
export var button = "PreviewErrorScreen-module--button--feb18";
export var container = "PreviewErrorScreen-module--container--bd6f0";
export var contentContainer = "PreviewErrorScreen-module--contentContainer--3e2f9";
export var divider = "PreviewErrorScreen-module--divider--80301";
export var errorSpan = "PreviewErrorScreen-module--errorSpan--a7e43";
export var message = "PreviewErrorScreen-module--message--179f8";
export var textContainer = "PreviewErrorScreen-module--textContainer--32a30";
export var title = "PreviewErrorScreen-module--title--41c54";